import { render } from "./Dashboard.vue?vue&type=template&id=1ecd5079&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=1ecd5079&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=1ecd5079&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecd5079"]])

export default __exports__